import { BaseService } from "./base.service";
import { IModule } from "models/ModuleModel";

class ModuleServiceInternal extends BaseService {
	getModuleList = async (): Promise<IModule[]> =>
		this.callApi<IModule[]>(`Module/GetModuleList`, "GET");

	getSystemTemplateModuleList = async (): Promise<IModule[]> =>
		this.callApi<IModule[]>(`Module/GetSystemTemplateModuleList`, "GET");
}

export const ModuleService = new ModuleServiceInternal();
